import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';

function SanitariaStranieriModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id === 14
    ? 'Assistenza'
    : type.name;

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Assistenza"
      riskRowCompanyGate
      excludedCompanyIds={[8, 16]}
    />
  );
}

export default SanitariaStranieriModalButtons;
